module.exports = __webpack_public_path__ + "static/media/thumbnail.8aab43f3.jpg";